import { Applicant } from '../applicant';
import { ScheduleInterview } from '../scheduleInterview';


export class ScheduleInterviewSerializer {
    fromJson(json: any): any {
        // const data = new ScheduleInterview();
        // data.applicantId = json.applicantId,
        // data.jobId= json.jobId
        if(json && json.applicantData && json.applicantData.length>0){
            for(let i=0; i<json.applicantData.length;i++){
                const applicantData = new Applicant();
                applicantData.id =json.applicantData[i].id;
                if(json.applicantData[i].lastName){
                    applicantData.name= json.applicantData[i].firstName + ' ' + json.applicantData[i].lastName + ' - ' + transfromPhoneNumber(json.applicantData[i].phone);
                }
                else{
                    applicantData.name= json.applicantData[i].firstName + ' - ' + transfromPhoneNumber(json.applicantData[i].phone);
                }
                applicantData.firstName =json.applicantData[i].firstName;
                applicantData.lastName=json.applicantData[i].lastName;
                applicantData.email=json.applicantData[i].email;
                applicantData.phone=json.applicantData[i].phone;
                applicantData.fullName=json.applicantData[i].lastName? json.applicantData[i].firstName + ' ' + json.applicantData[i].lastName : json.applicantData[i].firstName;
                json.applicantData[i]=applicantData;
            }
        }
        return json;
    }

    toJson(data: ScheduleInterview): any {
        return {
            startTime: data.startTime,
            statusId: data.statusId,
            applicantId: data.applicantId,
            jobId: data.jobId,
            interviewId:data.interviewId,
            interviewStepMapping:data.interviewStepMapping
            // .map(function (val) {
            //   return {id: val }  
            // })
                // {
                // interviewStep: data.interviewStepMapping.interviewStep,
                // user: data.interviewStepMapping.user,
                // notes: data.interviewStepMapping.notes,
                // pass: data.interviewStepMapping.pass,
                // interviewStepStatus: data.interviewStepMapping.interviewStepStatus,
                // comment: data.interviewStepMapping.comment
                // }
        };
    }
}
function transfromPhoneNumber(phone: any) {
    if(phone){
    //const countryCodeStr = phone.slice(0,2);
    const areaCodeStr = phone.slice(0,3);
    const midSectionStr = phone.slice(3,6);
    const lastSectionStr = phone.slice(6);

    return `${areaCodeStr}-${midSectionStr}-${lastSectionStr}`;
    }
    else{
        return "";
    }
}